import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function AirlineBookingDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Airline Booking")}
      endpoint={`/bookings/airline-bookings/${props.match.params.id}/`}
      successRoute={reverse("airlineBookingList")}
      errorRoute={reverse("airlineBookingList")}
    />
  )
}

AirlineBookingDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
